// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1Tok1","info":"UpdateTermsInfo_info__2C16L"};